export default function getAlternateUrl(url = '') {
  return `${process.env.NEXT_PUBLIC_VERCEL_URL}${url}`
}
